<div class="min-h-dvh bg-accent">
  <!-- Header -->
  <header class="p-3 md:p-6">
    <nav class="bg-primary w-[-webkit-fill-available] rounded-xl shadow-card-elevated">
      <div class="px-4">
        <div class="flex justify-between h-16 items-center">
          <!-- Logo -->
          <a href="/" class="flex-shrink-0">
            <img ngSrc="assets/images/logo_transparent_rectangle.png" alt="corpers.ng logo" class="w-28 -mb-1" width="410" height="65" priority>
          </a>

          <!-- Desktop Menu -->
          <div class="hidden md:flex space-x-6 text-white font-medium">
            <a href="/about" class="hover:text-accent transition-colors duration-200">About</a>
            <a href="/team" class="text-accent">Team</a>
            <a href="/login" class="hover:text-accent transition-colors duration-200">Login</a>
          </div>

          <!-- Desktop Button -->
          <div class="hidden md:block">
            <a href="/signup" class="btn-accent">
              Sign up
            </a>
          </div>

          <!-- Mobile Menu Button -->
          <div class="md:hidden">
            <button type="button" (click)="toggleMobileMenu()" class="text-white focus:outline-none">
              <mat-icon class="!size-6 text-2xl">menu</mat-icon>
            </button>
          </div>
        </div>
      </div>

      <!-- Mobile Menu -->
      <div id="mobile-menu" class="md:hidden px-4 pb-4 space-y-2 text-white font-medium"
        [ngClass]="{ hidden: !isMobileMenuOpen }">
        <a href="/about" class="block hover:text-accent transition-colors duration-200">About</a>
        <a href="/team" class="block text-accent">Team</a>
        <a href="/login" class="block hover:text-accent transition-colors duration-200">Login</a>
        <a href="/signup" class="block btn-accent text-center mt-2">
          Sign up
        </a>
      </div>
    </nav>
  </header>

  <!-- Hero Section -->
  <section class="bg-accent">
    <div class="max-w-4xl mx-auto px-6 md:px-12 lg:px-24 py-12 md:py-16">
      <h1 class="text-3xl md:text-4xl lg:text-5xl font-bold text-primary mb-4 text-center tracking-tight">
        Meet the team
      </h1>
      <p class="text-base md:text-lg text-primary/80 max-w-2xl mx-auto text-center leading-relaxed">
        Former corpers building the platform we wish we had. 
        Making your service year simpler, safer, and more meaningful.
      </p>
    </div>
  </section>

  <!-- Team Grid -->
  <section class="section-spacing bg-background-light">
    <div class="max-w-5xl mx-auto px-6 md:px-12 lg:px-24">
      <div class="flex flex-wrap justify-center gap-6">
        <!-- Team Member Card -->
        <article 
          *ngFor="let member of teamMembers" 
          class="team-card bg-white rounded-xl shadow-card hover:shadow-card-elevated transition-shadow duration-200 w-full sm:w-[calc(50%-0.75rem)] max-w-md"
        >
          <!-- Photo -->
          <div class="relative aspect-[4/3] w-full rounded-t-xl overflow-hidden bg-accent/20">
            <img
              [ngSrc]="member.imageUrl"
              [alt]="member.name"
              fill
              class="object-cover object-top"
            >
          </div>
          
          <!-- Content -->
          <div class="p-5">
            <!-- Info -->
            <div class="mb-3">
              <div class="flex items-center justify-between gap-2">
                <h3 class="text-xl font-semibold text-primary leading-tight">
                  {{ member.name }}
                </h3>
                <a 
                  *ngIf="member.linkedinUrl" 
                  [href]="member.linkedinUrl" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  class="text-[#0A66C2] hover:text-[#004182] transition-colors"
                  [attr.aria-label]="'View ' + member.name + ' on LinkedIn'"
                >
                  <svg class="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 01-2.063-2.065 2.064 2.064 0 112.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
                  </svg>
                </a>
              </div>
              <p class="text-sm font-medium text-brand-orange mt-1">
                {{ member.role }}
              </p>
            </div>
            
            <!-- Bio -->
            <p class="text-sm text-text-secondary leading-relaxed">
              {{ member.bio }}
            </p>
          </div>
        </article>
      </div>
    </div>
  </section>

  <!-- Join CTA Section -->
  <section class="bg-primary py-12 md:py-16">
    <div class="max-w-3xl mx-auto px-6 md:px-12 lg:px-24 text-center">
      <h2 class="text-xl md:text-2xl font-bold text-white mb-3">
        Want to join us?
      </h2>
      <p class="text-white/70 text-sm md:text-base mb-6 max-w-xl mx-auto">
        If you've served and want to help make the NYSC experience better, we'd love to hear from you.
      </p>
      <a 
        href="mailto:contact@corpers.ng" 
        class="btn-accent inline-flex items-center gap-2 text-sm"
      >
        Get in touch
        <mat-icon class="!text-lg">arrow_forward</mat-icon>
      </a>
    </div>
  </section>

  <footer class="bg-primary-dark text-white py-8 px-6 md:px-12">
    <div class="max-w-7xl mx-auto text-center text-white/60 text-sm">
      Say hi contact&#64;corpers.ng &middot; &copy; {{ fullYear }} corpers.ng
    </div>
  </footer>
</div>
